import React, { useState, useRef, useEffect, useContext } from "react";
import {
  FiSearch,
  FiShoppingCart,
  FiHeart,
  FiMenu,
  FiX,
  FiChevronDown,
} from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "./cartContext";
import { WishlistContext } from "./Wishlistcontext";
import { useSearch } from "./SearchContext";
import { CurrencyContext } from "./CurrencyContext";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [desktopDropdown1, setDesktopDropdown1] = useState(false);
  const [desktopDropdown2, setDesktopDropdown2] = useState(false);
  const [mobileDropdown1, setMobileDropdown1] = useState(false);
  const [mobileDropdown2, setMobileDropdown2] = useState(false);

  const { cartItems } = useContext(CartContext) || {};
  const { wishlistItems } = useContext(WishlistContext) || {};
  const { currency, setCurrency } = useContext(CurrencyContext);
  const { searchQuery, setSearchQuery } = useSearch();
  const navigate = useNavigate();

  const cartCount = cartItems?.length || 0;
  const wishlistCount = wishlistItems?.length || 0;

  const desktopDropdownRef1 = useRef(null);
  const desktopDropdownRef2 = useRef(null);

  const homeEssentials = [
    "HomeAppliances",
    "HomeDecor",
    "Furniture",
    "HomeSecurity",
    "BathroomEssentials",
  ];
  const personalCare = ["SkinCare", "HairCare", "WeightLoss", "Wellness"];
  const otherCategories = [
    "FoodBeverages",
    "FireSafety",
    "PetsCare",
    "GiftCards",
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        desktopDropdownRef1.current &&
        !desktopDropdownRef1.current.contains(e.target)
      )
        setDesktopDropdown1(false);
      if (
        desktopDropdownRef2.current &&
        !desktopDropdownRef2.current.contains(e.target)
      )
        setDesktopDropdown2(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim() !== "") {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-[9999]">
      {/* === Top Row === */}
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center text-xl font-bold text-[#fe7590]"
        >
          <img src="/assests/icons/favicon.png" alt="logo" className="w-[30px] mr-2 inline-block" />
          <h1 className="inline-block">Pure Clean Shopping</h1>
          
        </Link>

        {/* Search Bar */}
        <form
          onSubmit={handleSearchSubmit}
          className="hidden md:flex items-center bg-gray-100 rounded-full px-3 py-1 w-80"
        >
          <input
            type="text"
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-transparent px-2 py-1 focus:outline-none text-gray-700"
          />
          <button type="submit" className="text-gray-600 hover:text-[#fe7590]">
            <FiSearch className="w-5 h-5" />
          </button>
        </form>

        {/* Right Controls */}
        <div className="flex items-center space-x-3">
          {/* Currency Selector */}
          <select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            className="hidden md:block border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-1 focus:ring-[#fe7590]"
          >
            <option value="USD">USD $</option>
            <option value="INR">INR ₹</option>
          </select>

          {/* Wishlist */}
          <Link to="/wishlist" className="relative text-gray-600 hover:text-[#fe7590]">
            <FiHeart className="w-6 h-6" />
            {wishlistCount > 0 && (
              <span className="absolute -top-1 -right-2 bg-[#fe7590] text-white text-xs rounded-full px-1">
                {wishlistCount}
              </span>
            )}
          </Link>

          {/* Cart */}
          <Link to="/cart" className="relative text-gray-600 hover:text-[#fe7590]">
            <FiShoppingCart className="w-6 h-6" />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-2 bg-[#fe7590] text-white text-xs rounded-full px-1">
                {cartCount}
              </span>
            )}
          </Link>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-[#fe7590]"
          >
            {isMenuOpen ? <FiX className="w-7 h-7" /> : <FiMenu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {/* === Desktop Navigation === */}
      <div className="hidden md:flex bg-gray-50 border-t border-gray-200 justify-center space-x-6 py-2">
        {/* Home Essentials */}
        <div className="relative" ref={desktopDropdownRef1}>
          <button
            onClick={() => setDesktopDropdown1(!desktopDropdown1)}
            className="flex items-center hover:text-[#fe7590]"
          >
            Home Essentials
            <FiChevronDown
              className={`ml-1 transition-transform ${
                desktopDropdown1 ? "rotate-180" : ""
              }`}
            />
          </button>
          {desktopDropdown1 && (
            <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-md rounded-md">
              {homeEssentials.map((item) => (
                <Link
                  key={item}
                  to={`/categories/${item}`}
                  className="block px-4 py-2 hover:bg-[#fe7590] hover:text-white"
                >
                  {item.replace(/([A-Z])/g, " $1")}
                </Link>
              ))}
            </div>
          )}
        </div>

        {/* Personal Care */}
        <div className="relative" ref={desktopDropdownRef2}>
          <button
            onClick={() => setDesktopDropdown2(!desktopDropdown2)}
            className="flex items-center hover:text-[#fe7590]"
          >
            Personal Care
            <FiChevronDown
              className={`ml-1 transition-transform ${
                desktopDropdown2 ? "rotate-180" : ""
              }`}
            />
          </button>
          {desktopDropdown2 && (
            <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-md rounded-md">
              {personalCare.map((item) => (
                <Link
                  key={item}
                  to={`/categories/${item}`}
                  className="block px-4 py-2 hover:bg-[#fe7590] hover:text-white"
                >
                  {item.replace(/([A-Z])/g, " $1")}
                </Link>
              ))}
            </div>
          )}
        </div>

        {/* Other Categories */}
        {otherCategories.map((item) => (
          <Link
            key={item}
            to={`/categories/${item}`}
            className="hover:text-[#fe7590]"
          >
            {item.replace(/([A-Z])/g, " $1")}
          </Link>
        ))}
      </div>

      {/* === Mobile Menu === */}
      {isMenuOpen && (
        <div className="md:hidden bg-gray-50 border-t border-gray-200 px-4 py-4 space-y-2">
          {/* Search Bar */}
          <form
            onSubmit={handleSearchSubmit}
            className="flex items-center bg-gray-100 rounded-full px-3 py-1"
          >
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-transparent px-2 py-1 focus:outline-none text-gray-700"
            />
            <button type="submit" className="text-gray-600 hover:text-[#fe7590]">
              <FiSearch className="w-5 h-5" />
            </button>
          </form>

          {/* Currency */}
          <select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-2 py-1"
          >
            <option value="USD">USD $</option>
            <option value="INR">INR ₹</option>
          </select>

          {/* Home Essentials */}
          <div>
            <button
              onClick={() => setMobileDropdown1(!mobileDropdown1)}
              className="flex items-center justify-between w-full text-gray-700 hover:text-[#fe7590]"
            >
              Home Essentials
              <FiChevronDown
                className={`transition-transform ${
                  mobileDropdown1 ? "rotate-180" : ""
                }`}
              />
            </button>
            {mobileDropdown1 && (
              <div className="ml-3 mt-2 space-y-1">
                {homeEssentials.map((item) => (
                  <Link
                    key={item}
                    to={`/categories/${item}`}
                    className="block text-gray-600 hover:text-[#fe7590]"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.replace(/([A-Z])/g, " $1")}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Personal Care */}
          <div>
            <button
              onClick={() => setMobileDropdown2(!mobileDropdown2)}
              className="flex items-center justify-between w-full text-gray-700 hover:text-[#fe7590]"
            >
              Personal Care
              <FiChevronDown
                className={`transition-transform ${
                  mobileDropdown2 ? "rotate-180" : ""
                }`}
              />
            </button>
            {mobileDropdown2 && (
              <div className="ml-3 mt-2 space-y-1">
                {personalCare.map((item) => (
                  <Link
                    key={item}
                    to={`/categories/${item}`}
                    className="block text-gray-600 hover:text-[#fe7590]"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.replace(/([A-Z])/g, " $1")}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Other Categories */}
          {otherCategories.map((item) => (
            <Link
              key={item}
              to={`/categories/${item}`}
              className="block text-gray-700 hover:text-[#fe7590]"
              onClick={() => setIsMenuOpen(false)}
            >
              {item.replace(/([A-Z])/g, " $1")}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
